module.exports = __webpack_public_path__ + "static/media/HIRING-PROCESS.baf01aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/HIRING-PROCESS.png
// module id = 52
// module chunks = 0